import React from "react";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import addPV from "utils/add-pv.js";
import styles from "./FeaturePagesMenu.module.scss";

import menuListData from "./FeaturePagesMenuData.json";

const FeaturePagesMenu = ({ siteId, isHomepage, tabsList }) => {
  const [activeSubmenu, setActiveSubmenu] = React.useState(tabsList[0].slug);

  if (!tabsList) return null;
  return (
    <div className={styles.featurePagesMenu}>
      <div className={styles.featurePagesMenu__tabs}>
        {tabsList.map(i => {
          if (!menuListData[siteId][i.slug]) return null;
          return (
            <div
              key={i.title}
              onMouseEnter={() => setActiveSubmenu(i.slug)}
              className={classnames(styles.tab, i.slug === activeSubmenu ? styles.active : null)}
            >
              <Icon name={i.slug} size={24} className={styles.tab__icon} />
              <span className={styles.tab__title}>{i.title}</span>
              <Icon name="arrow-down" className={styles.tab__arrow} />
            </div>
          );
        })}
      </div>
      <div className={styles.featurePagesMenu__content}>
        {!!menuListData[siteId][activeSubmenu] &&
          menuListData[siteId][activeSubmenu].map(i => {
            if (isHomepage) {
              return (
                <a
                  className={styles.pageLink}
                  key={i.title}
                  href={i.url}
                  onClick={e =>
                    addPV(e, "trackEvent", {
                      category: "homePage-function",
                      action: "functionEnter_click",
                      label: `up|feature|${
                        tabsList.filter(i => i.slug === activeSubmenu)[0].title
                      }|${i.title}`,
                      path: i.url,
                      openInNewTab: false
                    })
                  }
                >
                  {i.title}
                </a>
              );
            }
            return (
              <a className={styles.pageLink} key={i.title} href={i.url}>
                {i.title}
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default FeaturePagesMenu;
